<template>
  <div class="VVmeeting">
    <div class="Active">
      <div class="Active_title">
        <div class="Meeting_name">{{meeting.meeting_name}}</div>
        <div class="Meeting_data">{{meeting.meeting_date}}</div>
      </div>
      <div class="Active_back">
        <div @click="Back">
          <img :src="imgpath.VV_back" />
        </div>
      </div>
      <div class="Meeting_detailed">
        <div>
          <div class="Meeting_detailed_Icon">
            <div>
              <img :src="imgpath.VV_time" />
            </div>
          </div>
          <div class="Meeting_detailed_right">
            <div class="Meeting_detailed_title">{{$t('m.MeetingDurationColon')}}</div>
            <div class="Meeting_detailed_content">{{meeting.meeting_long}}{{$t('m.Minute')}}</div>
          </div>
        </div>
        <div>
          <div class="Meeting_detailed_Icon">
            <div>
              <img :src="imgpath.VV_number" />
            </div>
          </div>
          <div class="Meeting_detailed_right">
            <div class="Meeting_detailed_title">{{$t('m.MeetingNoColon')}}</div>
            <div class="Meeting_detailed_content">{{meeting.vmr_id}}</div>
          </div>
        </div>
        <div>
          <div class="Meeting_detailed_Icon">
            <div>
              <img :src="imgpath.VV_password" />
            </div>
          </div>
          <div class="Meeting_detailed_right">
            <div class="Meeting_detailed_title">{{$t('m.MeetingPasswordColon')}}</div>
            <div class="Meeting_detailed_content">{{meeting.meeting_password}}</div>
          </div>
        </div>
        <div>
          <div class="Meeting_detailed_Icon">
            <div>
              <img :src="imgpath.VV_host" />
            </div>
          </div>
          <div class="Meeting_detailed_right">
            <div class="Meeting_detailed_title">{{$t('m.MeetinghostColon')}}</div>
            <div class="Meeting_detailed_content">{{meeting.cf_host_name}}</div>
          </div>
        </div>
        <div>
          <div class="Meeting_detailed_Icon">
            <div>
              <img :src="imgpath.VV_people" />
            </div>
          </div>
          <div class="Meeting_detailed_right">
            <div class="Meeting_detailed_title">{{$t('m.ParticipantsColon')}}</div>
            <div class="Meeting_detailed_content">{{meeting.cf_party_name}}</div>
          </div>
        </div>
      </div>
      <div class="Meeting_footer">
        <div id="roomJoinBut" @click="JionMeeting">{{$t('m.VideoConferenceRoomJoin')}}</div>
        <div id="mobileJoinBut" class="Meeting_APP" @click='APPjionMeeting'>{{$t('m.MobileAppJoin')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { selectConfDetail, addterminal } from "../../assets/js/url";
export default {
  data() {
    return {
      Id: "",
      meeting: {},
      terminalId: ""
    };
  },
  activated() {
    this.Id = this.$route.query.id;
    this.terminalId = this.$store.state.TremianlId;
	if(this.terminalId == "-1" || this.terminalId == ""){
		document.getElementById("roomJoinBut").style.display = "none";
	}
	else{
		document.getElementById("mobileJoinBut").style.display = "none";
	}
    if (window.sessionStorage.getItem("UUID")) {
      this.Meetdetail();
    } else {
      this.$router.push({
        path: "/login"
      });
    }
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    }
  },
  methods: {
    APPjionMeeting(){
     this.dmaDomain=this.$store.state.dmaDomain
     location.href=`SIP:${this.meeting.vmr_id}@${this.dmaDomain}`
    },
    JionMeeting() {
      this.$http
        .post(addterminal, {
          userUUId: window.sessionStorage.getItem("UUID"),
          addTerminaliUUId: this.terminalId,
          cfIdInWeMeet: this.meeting.id
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.$toast(this.$t('m.JoinOK'));
            this.$router.push({
              path: "/VVMeetingList"
            });
          } else {
		      if (res.data.data.errorDes == "会议不存在") {
				this.$toast(this.$t('m.MeetingNoOpen'));
			  } else {
				this.$toast(res.data.data.errorDes || this.$t('m.JoinFail'));
			  }            
          }
        });
    },
    Meetdetail() {
      this.$http
        .post(selectConfDetail, {
          id: this.Id
        })
        .then(
          res => {
            if (res.data.status == 2000) {
              this.meeting = res.data.data;
            } else {
              this.meeting = {};
			  this.$toast(res.data.data.errorDes || this.$t('m.GetDetailFail'));
            }
          },
          err => {
            this.$toast(this.$t('m.GetDetailFail'));
          }
        );
    },
    Back() {
      this.$router.push({ path: "/VVMeetingList" });
    }
  }
};
</script>
<style scoped>
html,
body {
  width: 100%;
  height: 100%;
  background: rgb(242, 242, 242);
}
.VVmeeting {
  position: fixed;
  top: 0;
  bottom:0;
  left:0;
  right: 0;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow: none;
  /* overflow: hidden; */
   background: rgb(242, 242, 242);
}

.Active {
  position: absolute;
  top: 0rem;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgb(242, 242, 242);
}
/* .Header_title {
  width: 75%;
  height: 0.8rem;
  font-size: 32px !important;
  line-height: 0.8rem;
  color: #f00;
  text-align: center;
  font-weight: 700;
}
.Header_Pic {
  width: 25%;
  height: 0.8rem;
  position: relative;
}
.Header_Pic div {
  width: 0.5rem;
  height: 0.5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
} */
.Active_title {
  height: 0.35rem;
  line-height: 0.35rem;
  font-size: 14px;
  /* padding-left: 0.2rem; */
  background: linear-gradient(to right, rgb(192, 0, 0), rgb(112, 48, 160));
  color: #fff;
}
.Meeting_name {
  float: left;
  width: 40%;
  height: 0.3rem;
  line-height: 0.3rem;
  padding-left:0.1rem;
}
.Meeting_data {
  float: right;
  width: 60%;
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 14px;
  color: #fff;
  text-align: right;
  padding-right: .1rem;
}
.Active_back {
  height: 0.6rem;
  width: 100%;
  line-height: 0.6rem;
  text-align: right;
  overflow: hidden;
}
.Active_back div {
  display: inline-block;
  height: 0.3rem;
  width: 0.3rem;
  color: cornflowerblue;
  margin-right: 0.3rem;
  margin-top: 0.15rem;
}
.Active_back img{
  width: 100%;
  height: 100%;
}
.Meeting_detailed {
  height: 4rem;
  padding: 0 0.2rem;
}
.Meeting_detailed .Meeting_detailed_right {
  float: left;
  width: 90%;
  height: 0.6rem;
  border-bottom: 1px solid #666;
}
.Meeting_detailed_title {
  /* display: inline-block; */
  height: 0.6rem;
  line-height: 0.8rem;
  font-size: 14px;
  color: black;
  padding-left: 0.1rem;
  float: left;
}
.Meeting_detailed_content {
  /* display: inline-block; */
  float: left;
  height: 0.6rem;
  line-height: 0.8rem;
  font-size: 14px;
  margin-left: 0.2rem;
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Meeting_footer {
  padding: 0 0.2rem;
  height: 0.5rem;
  line-height: 0.5rem;
  display: flex;
  justify-content: center;
}
.Meeting_footer div {

  height: 0.3rem;
  width: 1.5rem;
  line-height: 0.3rem;
  text-align: center;
  background: rgb(192, 0, 0);
  border-radius: 5px;
  color: #fff;
}
.Meeting_detailed_Icon {
  float: left;
  width: 10%;
  height: 0.6rem;
  line-height: 0.9rem;
  /* text-align: right; */
  padding-left: 0.1rem;
}
.Meeting_detailed_Icon div {
  display: inline-block;
  width: 0.2rem;
  height: 0.2rem;
}
.Meeting_detailed_Icon div img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/content/VVinfo.vue